import { render, staticRenderFns } from "./AdminProducts.vue?vue&type=template&id=4148696e&scoped=true&"
import script from "./AdminProducts.vue?vue&type=script&lang=js&"
export * from "./AdminProducts.vue?vue&type=script&lang=js&"
import style0 from "./AdminProducts.vue?vue&type=style&index=0&id=4148696e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4148696e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4148696e')) {
      api.createRecord('4148696e', component.options)
    } else {
      api.reload('4148696e', component.options)
    }
    module.hot.accept("./AdminProducts.vue?vue&type=template&id=4148696e&scoped=true&", function () {
      api.rerender('4148696e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/AdminProducts.vue"
export default component.exports